class EsSlick extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  async connectedCallback() {
    /**
     * Initialize the Slick slider only once
     */
    if (this.initialized) return;

    this.initialized = true;

    /**
     * Load the Slick slider library from Resource Coordinator
     */
    await ResourceCoordinator.requestVendor("Slick");

    const variant = this.getAttribute("variant");

    if (variant === "announcement") {
      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        vertical: true,
        autoplaySpeed: 2000,
        arrows: false,
      });

      return;
    }

    if (variant === "awards") {
      $(this).slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0721/7597/6768/files/left-chevron.png?v=1680782594"></div>',
        nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0721/7597/6768/files/chevron.png?v=1680782594"></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      })

      return;
    }

    if (variant === "customer-reviews") {
      $(this).slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:
          '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0721/7597/6768/files/left-chevron.png?v=1680782594"></div>',
        nextArrow:
          '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0721/7597/6768/files/chevron.png?v=1680782594"></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

      return;
    }

    $(this).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      dots: false,
      responsive: [
         {
          breakpoint: 1536,
          settings: {
            slidesToShow: 3.5,
          },
        },
          {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2.3,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1.6,
          },
        },
         {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.8,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1.1,
          },
        },
      ],
    });
  }
}

customElements.define("es-slick", EsSlick);
